import { AnyAction, ThunkAction } from '@reduxjs/toolkit';
import { StoreType } from '../../types/storeModels';
import MyFavoriteService from '../../services/myFavoriteService';
import { EventModel } from '../../types';
import { generateSearchParam } from '../utils';
import { RootState } from '../index';
import myFavoriteSlice from './myFavoritesSlice';

export const eventActions = myFavoriteSlice.actions;

export const fetchAllMyFavorites = (param: StoreType): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async dispatch => {
    const searchParam = generateSearchParam(param.searchParam);
    let response: any = await MyFavoriteService.getMyFavorite(param, searchParam);
    dispatch(eventActions.setMyFav({ searchInput: param.searchParam, data: response.data }));
  };
};

export const clearMyEvents = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    dispatch(eventActions.clearMyFav());
  };
};

export const clearMyEventsRegStatus = (): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    dispatch(eventActions.setRegistrationStatus({ status: false }));
  };
};

export const addFavorite = (event: EventModel): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    if (event._id) {
      MyFavoriteService.addFavorite(event._id).then(res => {
        dispatch(eventActions.appendMyFav({ data: { event: res.data.event } }));
        dispatch(eventActions.setRegistrationStatus({ status: true }));
      });
    }
  };
};

export const removeFavorite = (event: EventModel): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    if (event._id) {
      MyFavoriteService.removeFavorite(event._id).then(res => {
        dispatch(eventActions.removeMyFav({ data: { event: event } }));
        dispatch(eventActions.setRegistrationStatus({ status: true }));
      });
    }
  };
};
